import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostListener,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
} from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';

export const BREAK_POINT_TICK_MS = 200;

@Directive({
  selector: '[orderformBreakpoint]',
})
export class BreakpointDirective implements OnInit, AfterViewInit, OnDestroy {
  @Input() orderformBreakpoint: {
    [breakpoint: string]: string; // e.g class1 class2
  };

  @Input() orderformBreakpointOperator: '<' | '>' = '<';
  private _breakpointClassChanges = new Subject<string>();

  // Nur bei Änderungen und wenn die erste Klassen Änderung nicht * ist
  @Output()
  readonly breakpoint = this._breakpointClassChanges
    .asObservable()
    .pipe(distinctUntilChanged());

  private _destroy = new Subject();
  private _change$ = new Subject();

  constructor(
    private _element: ElementRef,
    private _renderer: Renderer2,
    private _ngZone: NgZone
  ) {}

  ngOnInit() {
    this.check();

    // Subscribe on change
    this._change$
      .pipe(debounceTime(BREAK_POINT_TICK_MS), takeUntil(this._destroy))
      .subscribe(() => {
        this.check();
      });
  }

  ngAfterViewInit() {
    this._ngZone.runOutsideAngular(() =>
      setTimeout(() => {
        this._change$.next(true);
      })
    );
  }

  @HostListener('window:resize')
  onResize() {
    this._change$.next(true);
  }

  check() {
    const addClasses = [];
    const removeClasses = [];
    const breakPoints = Object.keys(this.orderformBreakpoint);

    breakPoints.forEach((breakpoint) => {
      const _addCasses = () => {
        // Allow strings with multi classes
        this.orderformBreakpoint[breakpoint].split(' ').forEach((cssClass) => {
          this._renderer.addClass(this._element.nativeElement, cssClass);
          addClasses.push(cssClass);
        });
      };

      const _removeCasses = () => {
        // Allow strings with multi classes
        this.orderformBreakpoint[breakpoint].split(' ').forEach((cssClass) => {
          this._renderer.removeClass(this._element.nativeElement, cssClass);
          removeClasses.push(cssClass);
        });
      };

      requestAnimationFrame(() => {
        const width = this._element.nativeElement.offsetWidth;
        if (this.orderformBreakpointOperator === '<') {
          if (width < +breakpoint) {
            _addCasses();
          } else {
            _removeCasses();
          }
        } else if (this.orderformBreakpointOperator === '>') {
          if (width > +breakpoint) {
            _addCasses();
          } else {
            _removeCasses();
          }
        }
      });
    });

    this._breakpointClassChanges.next(addClasses.join(' ') || '*');
  }

  ngOnDestroy() {
    this._destroy.next(true);
    this._destroy.complete();
  }
}
